import { makeAutoObservable, reaction } from 'mobx';

import Mqtt from '../../services/mqtt';
import TopicHandlerStrategy from '../../services/mqtt/TopicHandlerStrategy';
import AckHandler from '../../services/mqtt/AckHandler';
import LikuMqtt from '../../services/mqtt/LikuMqtt/LikuMqtt';
import PlayerMqtt from '../../services/mqtt/LikuMqtt/PlayerMqtt';
import LikuHeartBeat from '../../services/mqtt/LikuHeartBeat';

class MqttStore {
	rootStore;
	isConnected = false;
	subscribedTopics = new Set();
	// receivedMessages = [];

	topicHandlerStrategy = TopicHandlerStrategy();
	mqttModule = null;
	ackHandler = null;

	likuMqtt = null;
	playerMqtt = null;
	likuHeartBeat = null;
	navigate = null;

	constructor(root) {
		makeAutoObservable(this, { navigate: false });
		this.rootStore = root;

		// this.connectedHandler = reaction(
		// 	() => this.mqttModule?.connected,
		// 	(connected) => {
		// 		if (connected) this.handleConnect();
		// 		else this.handleDisconnect();
		// 	},
		// );
	}

	setIsConnected(value) {
		this.isConnected = value;
		if (!value) {
			this.likuHeartBeat?.setIsHeartBeat(false);
		}
	}

	setNavigate(navigate) {
		this.navigate = navigate;
	}

	getIsConnected() {
		return this.isConnected;
	}

	handleCustomAlarmMqtt(callback) {
		const callbackResult = callback();
		const { likus, topic, message } = callbackResult;
		let callBackCount = 0;
		likus.forEach((liku) => {
			const topic = `liku/${liku}/robot/custom/set`;
			this.subscribeToTopic(topic);
			this.publishMessage(topic, message, (error) => {
				if (error) {
					console.log('Publish error: ', error);
				}
			});
			this.unsubscribeToTopic(topic);
		});
		// setTimeout(() => {
		// 	this.disconnect();
		// }, 1000);
	}

	connect(callback, { initializeOnConnect = false } = {}) {
		if (this.mqttModule) {
			if (
				!initializeOnConnect &&
				callback &&
				(callback().type === 'custom' ||
					callback().type === 'add' ||
					callback().type === 'delete')
			) {
				this.handleCustomAlarmMqtt(callback);
			} else {
				this.mqttModule.reconnect(initializeOnConnect ? callback : undefined);
			}
		} else {
			this.mqttModule = Mqtt(
				this.topicHandlerStrategy,
				this.setIsConnected.bind(this),
				callback,
			);

			if (
				!initializeOnConnect &&
				callback &&
				(callback().type === 'custom' ||
					callback().type === 'add' ||
					callback().type === 'delete')
			) {
				const intervalId = setInterval(() => {
					if (this.isConnected) {
						this.handleCustomAlarmMqtt(callback);
						setTimeout(() => {
							this.disconnect();
						}, 1000);
						clearInterval(intervalId);
					}
				}, 100);
				return;
			}

			this.likuHeartBeat = LikuHeartBeat(
				() => this.getIsConnected(),
				// this.rootStore.playerControlStore.getIsLoading.bind(
				// 	this.rootStore.playerControlStore,
				// ),
				// this.rootStore.playerControlStore.getIsStart.bind(
				// 	this.rootStore.playerControlStore,
				// ),
			);
			this.likuMqtt = LikuMqtt(
				this.getMqttFunction(),
				this.likuHeartBeat,
				(path) => this.navigate?.(path),
			);
			this.playerMqtt = PlayerMqtt(this.getMqttFunction());
			this.ackHandler = AckHandler(this.mqttModule);
		}
	}

	async disconnect() {
		const unsubscribeTasks = Array.from(this.subscribedTopics).map((topic) =>
			this.unsubscribeToTopic(topic),
		);

		await Promise.all(unsubscribeTasks); // 비동기 unsubscribe 완료 대기
		console.log('All topics unsubscribed');

		this.mqttModule?.disconnect();
		this.mqttModule = null;
		console.log('Client disconnected');
	}

	publishMessage(topic, message, options) {
		this.mqttModule?.publish(topic, message, options);
		this.ackHandler?.generateAckId(topic, message);
	}

	subscribeToTopic(topic, handler) {
		// if (!this.subscribedTopics.has(topic)) {
		if (topic.includes('ack')) {
			handler = {
				handlerFunction: this.ackHandler?.resolveAck.bind(this.ackHandler),
			};
		}

		if (handler) {
			this.addHandler(topic, handler);
		}
		this.mqttModule?.subscribe?.(topic);

		if (!this.subscribedTopics.has(topic)) {
			this.subscribedTopics.add(topic);
		}
	}

	unsubscribeToTopic(topic) {
		return new Promise((resolve) => {
			if (this.subscribedTopics.has(topic)) {
				this.topicHandlerStrategy.removeHandlerAll(topic);

				// mqtt.js에서 unsubscribe는 콜백 기반
				this.mqttModule.unsubscribe(topic, () => {
					this.subscribedTopics.delete(topic);
					resolve();
				});
			} else {
				resolve();
			}
		});
	}

	addHandler(topic, handler) {
		this.topicHandlerStrategy.addHandler(topic, handler);
	}

	removeHandler(topic, handler) {
		this.topicHandlerStrategy.removeHandler(topic, handler);
	}

	getMqttFunction() {
		return {
			publish: this.publishMessage.bind(this),
			subscribe: this.subscribeToTopic.bind(this),
			unsubscribe: this.unsubscribeToTopic.bind(this),
			addHandler: this.addHandler.bind(this),
			removeHandler: this.removeHandler.bind(this),
		};
	}

	// dispose() {
	// 	this.connectedHandler();
	// }
}

export default MqttStore;
